<template>
  <div id="suppliers" class="px-4 py-4">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'surgery-create' })"
      >
        <v-icon left>
          add_circle
        </v-icon>
        Add
      </v-btn>
    </div>
    <surgery-list />
  </div>
</template>
<script>
import SurgeryList from "@/components/surgery_management/SurgeryList.vue";
export default {
  components: {
    SurgeryList
  }
};
</script>
